import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import useAprovechamiento from "../../../hooks/administrador/general/useAprovechamiento";
import "../../../styles/administrador.css";

const Aprovechamiento = ({ year, mes, token, idAdministrador }) => {
  const chartRef = useRef(null);
  const data = useAprovechamiento(year, mes, token, idAdministrador);
  const [originalOption, setOriginalOption] = useState(null);

  useEffect(() => {
    if (Array.isArray(data) && data.length && chartRef.current) {
      const chartDom = chartRef.current;
      let myChart =
        echarts.getInstanceByDom(chartDom) || echarts.init(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      const colorPalette = [
        "#d1dc5a",
        "#e0f7e0",
        "#6ac5cb",
        "#45444e",
        "#a3b85b",
        "#3a6b74",
      ];

       
      const totalAprovechamiento = data.reduce(
        (sum, item) => sum + (parseInt(item.cantidad, 10) || 0),
        0
      );

       
      data.sort((a, b) => parseInt(b.cantidad, 10) - parseInt(a.cantidad, 10));

      const option = {
        title: {
          text: "Nfu entregados por aprovechamiento",
          subtext: `TOTAL RECOLECTADOS: ${totalAprovechamiento.toLocaleString()} [U]`,
          left: "center",
          textStyle: {
            fontSize: 18,
            fontWeight: "bold",
          },
          subtextStyle: {
            fontSize: 12,
            fontWeight: "bold",
          },
        },
        tooltip: {
          trigger: "item",
          backgroundColor: "#fff",
          borderColor: "#ccc",
          borderWidth: 1,
          textStyle: {
            fontSize: 11,  
            color: "#333",
          },
          confine: true,
          extraCssText: "max-width: 160px; white-space: pre-line;",
          formatter: (params) => {
            var porcentaje = Math.round(params.percent * 10) / 10;
            return `<span style="font-size:11px;"><b>${
              params.name
            }</b></span><br/>${porcentaje}%<br/>(${params.value.toLocaleString()} NFU)`;
          },
        },
        legend: {
          orient: "horizontal",
          bottom: 0,
          textStyle: {
            fontSize: 12,
          },
          formatter: function (name) {
            const item = data.find((d) => d.tipo_aprovechamiento === name);
            if (item) {
              return `${name}: ${parseInt(item.cantidad, 10).toLocaleString()}`;
            }
            return name;
          },
        },
        color: colorPalette,
        series: [
          {
            type: "pie",
            radius: "70%",
            center: ["50%", "50%"],
            data: data.map((item, index) => ({
              name: item.tipo_aprovechamiento,
              value: parseInt(item.cantidad, 10) || 0,
              itemStyle: {
                color: colorPalette[index % colorPalette.length],
              },
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              show: false,
            },
          },
        ],
      };

      setOriginalOption(option);
      myChart.setOption(option);

       
      const updateChart = () => {
        myChart.resize();
      };

      window.addEventListener("resize", updateChart);

      return () => {
        window.removeEventListener("resize", updateChart);
        if (myChart && !myChart.isDisposed()) {
          myChart.dispose();
        }
      };
    }
  }, [data]);

  return <div className="grafica" ref={chartRef}></div>;
};

export default Aprovechamiento;
